/**
 * Zwraca URL endpointu WC AJAX.
 */
export const getWcAjaxUrl = endpoint => {
    const params =
        window.wc_cart_fragments_params || window.woocommerce_params || {};

    if (params.wc_ajax_url) {
        return params.wc_ajax_url.replace('%%endpoint%%', endpoint);
    }

    return `/?wc-ajax=${endpoint}`;
};

/**
 * Wysyła request POST do endpointu WC AJAX.
 */
export const postWcAjax = async (endpoint, payload) => {
    const response = await fetch(getWcAjaxUrl(endpoint), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        body: payload.toString(),
    });

    const text = await response.text();

    try {
        return JSON.parse(text);
    } catch (error) {
        throw new Error(text || `HTTP ${response.status}`);
    }
};

/**
 * Podmienia fragmenty WooCommerce zwrócone przez AJAX.
 */
export const replaceWooFragments = fragments => {
    Object.entries(fragments || {}).forEach(([selector, html]) => {
        document.querySelectorAll(selector).forEach(node => {
            const temp = document.createElement('div');
            temp.innerHTML = html;
            const newNode = temp.firstElementChild;
            if (!newNode) {
                return;
            }

            if (node.id === 'mini-cart-wrapper') {
                node.innerHTML = newNode.innerHTML;
                return;
            }

            node.replaceWith(newNode);
        });
    });
};
